import { Overline, OrnamentDivider } from "@/components/GoldDivider";
import CtaSection from "@/components/CtaSection";
import PhotoGrid from "@/components/PhotoGrid";
import usePhotos from "@/hooks/usePhotos";

export default function Portfolio() {
  const { images, loading } = usePhotos("portfolio");

  return (
    <div className="bg-ivory">
      <section className="pt-36 pb-16 px-6 velvet-deep" data-testid="portfolio-hero">
        <div className="max-w-5xl mx-auto">
          <Overline>Portfolio</Overline>
          <OrnamentDivider className="mt-6 !justify-start" width={200} />
          <h1 className="font-serif text-5xl sm:text-6xl lg:text-7xl font-light text-ivory mt-5 leading-[1.03]">
            Over two decades of finished work.
          </h1>
          <p className="text-[#A9B7CE] text-lg sm:text-xl mt-6 max-w-2xl leading-relaxed">
            Real kitchens, baths and built-ins installed in homes across North Louisiana. Tap any photo to view it full size.
          </p>
        </div>
      </section>

      <section className="py-16 sm:py-20 px-6" data-testid="portfolio-grid-section">
        <div className="max-w-7xl mx-auto">
          <PhotoGrid images={images} loading={loading} columns={4} placeholderCount={12}
            placeholderNote="This is where your 100+ install photos will live. Upload them from the admin dashboard (Portfolio section)." />
        </div>
      </section>

      <CtaSection />
    </div>
  );
}
